import React from "react";
import '../Styles/FastTrackDisplayWidget.scss';

import DateHelpers from "../Helper/DateHelpers";

const FastTrackDisplayWidget = ({ fastTrack, numberOfSpots, paymentAmount }) => {
   console.log(fastTrack)
   var selectedOption = (fastTrack.selectedOption == 'Option1') ? "Second Free Counselor" : "Free Lodging"
   return (
      <div>
         <div className="FastTrackDisplayWidgetContainer">
            <div className="FastTrackDisplayWidgetContent">
               <div className="FastTrackDisplayWidgetHeading">
                  Review Fast Track Reservation Details
               </div>
               <div className="FastTrackDisplayWidgetBenefits">
                  <div className="FastTrackDisplayWidgetSlotReserved">
                     <h3>Slots Reserved:</h3>
                     <p className="FastTrackBenefitDescription">
                        {numberOfSpots}
                     </p>
                  </div>
                  <div className="FastTrackDisplayWidgetFreeCounselor1">
                     <h3>Standard Benefits:</h3>
                     <li>Free Counselor</li>
                     <li>Free Cookout</li>



                  </div>
                  <div className="FastTrackDisplaySelectedOption">
                     <h3>Selected Option:</h3>
                     <li>{selectedOption}</li>
                  </div>
               </div>
                  <div className="FastTrackDisplayWidgetPaymentInstructions">
                     <div className="FastTrackDisplayWidgetPaymentInstructionsContent">
                        <div className="FastTrackDisplayWidgetPaymentInstructions">
                           <dl>
                              <dd className="fastTrackPayment">Cost: ${paymentAmount}.00</dd>
                           </dl>
                        </div>
                        <div>

                        </div>
                     </div>
                  </div>
            </div>
         </div>
      </div>
   )
}

export default FastTrackDisplayWidget;